var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import 'bootstrap/dist/css/bootstrap.min.css';
import HomeHeader from './common/HomeHeader';
import Footer from './common/Footer';
import usineLoader from '../imgs/usineLoader.png';
import '../styles/Loader.css';
export default function Loader(props) {
    return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ style: {
                    zIndex: 3,
                    backgroundImage: "url(".concat(usineLoader, ")"),
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    width: '100%',
                    height: '100%',
                } }, { children: [_jsx(HomeHeader, { subsidiary: props.subsidiary }), _jsx(Footer, {})] })), _jsx("div", { id: "loader", style: { pointerEvents: 'none' } })] }));
}
